import * as actionTypes from "../actions";
import {
  openFile,
  notifySuccess,
  notifyError,
} from "../../../components/Utils";
import { CONNECTION_TASK_TYPES } from "../components/Utils";

export const initialState = {
  adConnections: [],
  anpConnections: [],
  adWorkplaceTasks: [],
  ptConnections: [],
  delphiConnections: [],
  jarvisConnections: [],

  currentADConnectionType: "",
  currentANPConnectionType: "",
  currentADWorkplaceType: "",
  currentPTConnectionType: "",
  currentDelphiConnectionType: "",
  currentJarvisConnectionType: "",

  selectedADConnections: [],
  selectedANPConnections: [],
  selectedADWorkplaceTasks: [],
  selectedPTConnections: [],
  selectedDelphiConnections: [],
  selectedJarvisConnections: [],
};

export const initCurrentConnectionTypes = (state) => {
  const currentADConnectionType =
    state.currentADConnectionType !== ""
      ? state.currentADConnectionType
      : `${CONNECTION_TASK_TYPES.CREATE}-AD-CONNECTION`;
  const currentANPConnectionType =
    state.currentANPConnectionType !== ""
      ? state.currentANPConnectionType
      : `${CONNECTION_TASK_TYPES.CREATE}-ANP-CONNECTION`;
  const currentADWorkplaceType =
    state.currentADWorkplaceType !== ""
      ? state.currentADWorkplaceType
      : `${CONNECTION_TASK_TYPES.CREATE}-VBG-CONNECTION`;
  const currentPTConnectionType =
    state.currentPTConnectionType !== ""
      ? state.currentPTConnectionType
      : `${CONNECTION_TASK_TYPES.CREATE}-PT-CONNECTION`;
  const currentDelphiConnectionType =
    state.currentDelphiConnectionType !== ""
      ? state.currentDelphiConnectionType
      : `${CONNECTION_TASK_TYPES.CREATE}-DELPHI-CONNECTION`;
  const currentJarvisConnectionType =
    state.currentJarvisConnectionType !== ""
      ? state.currentJarvisConnectionType
      : `${CONNECTION_TASK_TYPES.CREATE}-JARVIS-CONNECTION`;
  return {
    currentADConnectionType,
    currentANPConnectionType,
    currentADWorkplaceType,
    currentPTConnectionType,
    currentDelphiConnectionType,
    currentJarvisConnectionType,
  };
};

const getTaskTitle = (connectionType, isSingular) => {
  let type = "Zugangsaufgabe";
  switch (connectionType) {
    case "AD":
      type = "Vodafone Accountaufgabe";
      break;
    case "PT":
      type = "iProv-Zugangsaufgabe";
      break;
    case "DELPHI":
      type = "Delphi-Zugangsaufgabe";
      break;
    case "ANP":
      type = "AN-Portal Zugangsaufgabe";
      break;
    case "VBG":
      type = "VBG-CSC Kennung";
      if (!isSingular) {
        type += "e";
      }
      break;
    case "JARVIS":
      type = "JARVIS-Zugangsaufgabe";
      break;
    default:
      break;
  }
  return isSingular ? type : `${type}n`;
  // return connectionType === "VBG"
  //   ? "VBG-CSC Kennungen"
  //   : `${connectionType}-Zugänge`;
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    // filter connections
    case actionTypes.FILTER_CONNECTIONS: {
      // console.log(
      //   "REDUX REDUCER - filtering",
      //   action.connectionType,
      //   "connections by task",
      //   action.taskType,
      //   state.connections
      // );
      const { connectionType, taskType } = action;
      const key =
        connectionType === "VBG"
          ? "currentADWorkplaceType"
          : `current${connectionType}ConnectionType`;
      return {
        ...state,
        [key]: taskType,
      };
    }

    // setting selected connections
    case actionTypes.SET_SELECTED_AD_CONNECTION:
      return {
        ...state,
        selectedADConnections: action.selected,
      };
    case actionTypes.SET_SELECTED_ANP_CONNECTION:
      return {
        ...state,
        selectedANPConnections: action.selected,
      };
    case actionTypes.SET_SELECTED_AD_WORKPLACE_TASK:
      return {
        ...state,
        selectedADWorkplaceTasks: action.selected,
      };
    case actionTypes.SET_SELECTED_PT_CONNECTION:
      return {
        ...state,
        selectedPTConnections: action.selected,
      };
    case actionTypes.SET_SELECTED_DEPLPHI_CONNECTION:
      return {
        ...state,
        selectedDelphiConnections: action.selected,
      };
    case actionTypes.SET_SELECTED_JARVIS_CONNECTION:
      return {
        ...state,
        selectedJarvisConnections: action.selected,
      };

    // export AD-Connections, PT Connections, Delphi-Connections as CSV
    case actionTypes.EXPORT_ADCONNECTIONS:
    case actionTypes.EXPORT_ANPCONNECTIONS:
    case actionTypes.EXPORT_PTCONNECTIONS:
    case actionTypes.EXPORT_DELPHICONNECTIONS:
    case actionTypes.EXPORT_ADWORKPLACE_TASKS:
    case actionTypes.EXPORT_JARVISCONNECTIONS:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.EXPORT_ADCONNECTIONS_SUCCESS:
    case actionTypes.EXPORT_PTCONNECTIONS_SUCCESS:
    case actionTypes.EXPORT_DELPHICONNECTIONS_SUCCESS:
    case actionTypes.EXPORT_ADWORKPLACE_TASKS_SUCCESS:
    case actionTypes.EXPORT_JARVISCONNECTIONS_SUCCESS: {
      const title = getTaskTitle(action.connectionType);
      openFile(action.result.filePath);
      notifySuccess({
        summary: `${title} exportieren`,
        detail: `Die gewählte ${title} wurden erfolgreich exportiert.`,
      });
      const listName =
        action.connectionType === "VBG"
          ? "selectedADWorkplaceTasks"
          : `selected${action.connectionType}Connections`;
      return {
        ...state,
        loading: false,
        [listName]: [],
      };
    }
    case actionTypes.EXPORT_ADCONNECTIONS_FAILURE:
    case actionTypes.EXPORT_PTCONNECTIONS_FAILURE:
    case actionTypes.EXPORT_DELPHICONNECTIONS_FAILURE:
    case actionTypes.EXPORT_ADWORKPLACE_TASKS_FAILURE:
    case actionTypes.EXPORT_JARVISCONNECTIONS_FAILURE: {
      const title = getTaskTitle(action.connectionType);
      notifyError({
        summary: `${title} exportieren`,
        detail: `Die gewählte ${title} konnten nicht exportiert werden.`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };
    }
    case actionTypes.EXPORT_ANPCONNECTIONS_SUCCESS: {
      const title = getTaskTitle(action.connectionType);
      openFile(action.result.filePath);
      notifySuccess({
        summary: `${title} exportieren`,
        detail: `Die gewählte ${title} wurden erfolgreich exportiert.`,
      });
      return {
        ...state,
        loading: false,
        selectedANPConnections: [],
      };
    }
    case actionTypes.EXPORT_ANPCONNECTIONS_FAILURE: {
      const title = getTaskTitle(action.connectionType);
      notifyError({
        summary: `${title} exportieren`,
        detail: `Die gewählte ${title} konnten nicht exportiert werden.`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };
    }

    // close connection task
    case actionTypes.CLOSE_CONNECTION_TASK:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CLOSE_CONNECTION_TASK_SUCCESS: {
      const title = getTaskTitle(action.connectionType, action.isSingle);
      notifySuccess({
        summary: `${title} abschließen`,
        detail: `Die gewählte ${title} wurde${action.isSingle ? "" : "n"} erfolgreich abgeschlossen.`,
      });
      const selectedADConnections = action.connectionType === "AD" ? [] : state.selectedADConnections;
      const selectedANPConnections = action.connectionType === "ANP" ? [] : state.selectedANPConnections;
      const selectedDelphiConnections = action.connectionType === "DELPHI" ? [] : state.selectedDelphiConnections;
      const selectedPTConnections = action.connectionType === "PT" ? [] : state.selectedPTConnections;
      const selectedJarvisConnections = action.connectionType === "JARVIS" ? [] : state.selectedJarvisConnections;
      return {
        ...state,
        loading: false,
        selectedADConnections,
        selectedANPConnections,
        selectedDelphiConnections,
        selectedPTConnections,
        selectedJarvisConnections,
      };
    }
    case actionTypes.CLOSE_CONNECTION_TASK_FAILURE: {
      const title = getTaskTitle(action.connectionType, action.isSingle);
      notifyError({
        summary: `${title} abschließen`,
        detail: `Die gewählte ${title} konnte${action.isSingle ? "" : "n"} nicht abgeschlossen werden.`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };
    }

    // close ad-workplace tasks
    case actionTypes.CLOSE_ADWORKPLACE_TASKS:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CLOSE_ADWORKPLACE_TASKS_SUCCESS: {
      notifySuccess({
        summary: `VBG-CSC Kennungen schließen`,
        detail: `Der gewählte VBG-CSC Kennungen wurden erfolgreich geschlossen.`,
      });
      return {
        ...state,
        loading: false,
        selectedADWorkplaceTasks: [],
      };
    }
    case actionTypes.CLOSE_CONNECTION_TASK_FAILURE: {
      notifyError({
        summary: `VBG-CSC Kennungen schließen`,
        detail: `Der gewählte VBG-CSC Kennungen konnte nicht abgeschlossen werden.`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };
    }

    // delete connection task
    case actionTypes.DELETE_CONNECTION_TASK:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.DELETE_CONNECTION_TASK_SUCCESS: {
      const title = getTaskTitle(action.connectionType, true);
      notifySuccess({
        summary: `${title} löschen`,
        detail: `Die gewählte ${title} wurde erfolgreich gelöscht.`,
      });
      return {
        ...state,
        loading: false,
      };
    }
    case actionTypes.DELETE_CONNECTION_TASK_FAILURE: {
      const title = getTaskTitle(action.connectionType, true);
      notifyError({
        summary: `${title} löschen`,
        detail: `Die gewählte ${title} konnte nicht gelöscht werden.`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };
    }

    default:
      return null;
  }
};
